import { Reducer } from "redux";
import { produce } from "immer";

import { FLOOR_TRADE_BUILT_ELEMENT_COUNTS_LOADED, FloorTradeBuiltElementCountsLoadedEvent } from "../../../events/loaded/projects/floor_trade_built_element_counts_loaded";

/**
 * Built counts keyed by floor firebase id, then trade code. The gateway omits
 * anything with nothing built, so check they loaded before reading a miss.
 */
export type FloorTradeBuiltElementCounts = { [floorFirebaseId: string]: { [tradeCode: string]: number } }

export type FloorTradeBuiltElementCountsStore = {
  byFirebaseProjectId: { [projectId: string]: FloorTradeBuiltElementCounts }
}

const reduceFloorTradeBuiltElementCounts: Reducer<FloorTradeBuiltElementCountsStore, FloorTradeBuiltElementCountsLoadedEvent> = (
  builtElementCountsStore: FloorTradeBuiltElementCountsStore = {
    byFirebaseProjectId: {},
  },
  event
) => {
  return produce<FloorTradeBuiltElementCountsStore>(builtElementCountsStore, (draft) => {
    if (!draft.byFirebaseProjectId) {
      draft.byFirebaseProjectId = {};
    }
    switch (event.type) {
      case FLOOR_TRADE_BUILT_ELEMENT_COUNTS_LOADED: {
        draft.byFirebaseProjectId[event.payload.projectId] = event.payload.builtElementCounts;
        return draft;
      }
      default: {
        return draft;
      }
    }
  });
};

export default reduceFloorTradeBuiltElementCounts;
